import { xmREQ_Work,xmREP_Work } from './Req.js';

export async function nGetCsrf() {
  try {
    const rep = await xmREQ_Work('/auth/csrf-token');
    if (rep) { window.xmRET_CSF = rep; }
    return rep;
  } catch (err) {
    //throw err;
  }
}


export async function nRefreshAccessToken(FUN_Error = () => {}) {
  const auth = localStorage.getItem('auth');

  //未登入不執行
  if (!auth||auth!==1) return;

  await nGetCsrf();

  try {
    const rep = await xmREP_Work('/auth/refresh');
    return rep;
  } catch (err) {
    FUN_Error(err);
    //throw err;
  }
}
